// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RadioButtonList from '../../radio-button-list/radio-button-list';

const RadioButtonFilterBody = props =>
    <section className='radio-button-filter-body'>
        <RadioButtonList
            items={props.list}
            onItemsUpdate={props.onItemUpdate}
            selectedKey={props.selectedItem.key}
        />
    </section>;

RadioButtonFilterBody.displayName = 'RadioButtonFilterBody';
RadioButtonFilterBody.propTypes = {
    list: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onItemUpdate: PropTypes.func.isRequired,
    selectedItem: PropTypes.instanceOf(KeyValuePair)
};

export default RadioButtonFilterBody;



// WEBPACK FOOTER //
// ./src/shared/components/facets/radio-button-filter/radio-button-filter-body.js